import React, {useState, useEffect} from 'react';
import {t} from 'react-switch-lang';
import {Link, NavLink} from 'react-router-dom';
import './Sidebar.scss';
import Logo from './img/logoSidebar.svg';
import DashboardImg from './img/dashboard.svg';
import RiskEntryImg from './img/risks.svg';
import IndicatorsImg from './img/indicators.svg';
import ReportsImg from './img/reports.svg';
import RevisionsImg from './img/revisions.svg';
import SettingsImg from './img/settings.svg';
import roles from '../../utils/roles';
import {useUserContext} from '../../contexts/UserContext';

const Sidebar = ({
  closeSidebar,
  toggleSidebarExtra,
  toggleRisksExtra,
  toggleReportsExtra,
}) => {
  const [showAdministration, setShowAdministration] = useState(false);

  const [showRisks, setShowRisks] = useState(true);
  const [showReports, setShowReports] = useState(false);
  const[showRevisions,setShowRevisions] = useState(false)

  const administrationRoles = [
    roles.role_super_admin,
    roles.role_technological,
    roles.role_admin,
    roles.role_head_of_internal_audit,
  ];
  const keyIndicatorsRoles = [
    roles.role_super_admin,
    roles.role_risk_sector,
    roles.role_user_in_charge,
    roles.role_responsible_user,
  ];
  const reportsRoles = [
        roles.role_super_admin,
        roles.role_technological,
        roles.role_risk_sector,
        roles.role_user_in_charge,
        roles.role_responsible_user,
        roles.role_admin,
        roles.role_internal_audit_responsible,
        roles.role_head_of_internal_audit,
        roles.role_internal_auditor
  ];

  const revisionRoles = [
    roles.role_super_admin,
    roles.role_admin,
    roles.role_internal_auditor,
    roles.role_head_of_internal_audit,
    roles.role_internal_audit_responsible,
    roles.role_sector_director,
  ];

  const user = useUserContext();

  const userRoles = user?.authorities;

  const difUserRoles = () => {
    const result = administrationRoles.filter((element) =>
      userRoles?.includes(element)
    );
    setShowAdministration(result.length > 0);
    const result2 = reportsRoles.filter((element) =>
      userRoles?.includes(element)
    );
    {console.log(userRoles)}
    setShowReports(result2.length > 0);

    const result3 = revisionRoles.filter((element) =>
        userRoles?.includes(element)
    );
    setShowRevisions(result3.length > 0);
  };

  const check = keyIndicatorsRoles.some((r) => userRoles?.includes(r));
 

  useEffect(() => {
    if (Array.isArray(userRoles)) {
      difUserRoles();
    }
  }, [userRoles]);
  return (
    <div className="sidebar">
      <div className="logo" onClick={() => toggleSidebarExtra()}>
        <Link to="/dashboard" className="logo-link">
          <img src={Logo} alt="logo" />
        </Link>
      </div>

      <NavLink
        to="/dashboard"
        className="nav-tooltip-container links"
        activeClassName="active"
      >
        <img src={DashboardImg} alt={'dashboard'} />
        <div className="tooltip-text">
          <span>{t('sidebar.dashboard')}</span>
        </div>
      </NavLink>

      {showRisks && check && (
        <button
          className="links nav-tooltip-container risks"
          onClick={() => toggleRisksExtra('risks')}
        >
          <img src={RiskEntryImg} alt="risks" />
          <div className="tooltip-text">
            <span>{t('sidebar.new-risk')}</span>
          </div>
        </button>
      )}

      {check && (
        <NavLink
          to="/key-risk-indicators"
          className="nav-tooltip-container links"
          activeClassName="active"
        >
          <img src={IndicatorsImg} alt={'key-risk-indicators'} />
          <div className="tooltip-text">
            <span>{t('sidebar.keyRiskIndicators')}</span>
          </div>
        </NavLink>
      )}
      {showReports && (
        <button
          className="links nav-tooltip-container reports"
          onClick={() => toggleReportsExtra('reports')}
        >
          <img src={ReportsImg} alt="reports" />
          <div className="tooltip-text">
            <span>{t('sidebar.reports')}</span>
          </div>
        </button>
      )}
      {showAdministration && (
        <button
          className="links nav-tooltip-container settings"
          onClick={() => toggleSidebarExtra('administration')}
        >
          <img src={SettingsImg} alt="settings" />
          <div className="tooltip-text">
            <span>{t('sidebar.settings')}</span>
          </div>
        </button>
      )}
      {showRevisions && (

        <NavLink
        to="/revisions"
        className="nav-tooltip-container links"
        activeClassName="active"
        >
           <img src={RevisionsImg} alt="revisions" />
          <div className="tooltip-text">
          <span>{t('sidebar.revisions')}</span>
         </div>
        </NavLink>
      )}
    </div>
  );
};

export default Sidebar;
